import type { ApplyFiltersResponseAction } from './applyFilters.action';
import type { ClearFilterEditorResponseAction } from './clearFilterEditor.action';
import type { RevertFilterEditorResponseAction } from './revertFilterEditor.action';
import type { UpdateArchivedFilterResponseAction } from './updateArchivedFilter.action';
import type { UpdateCampaignFilterResponseAction } from './updateCampaignFilter.action';
import type { UpdateChannelFilterResponseAction } from './updateChannelFilter.action';
import type { UpdateCreatedDateRangeFilterResponseAction } from './updateCreatedDateRangeFilter.action';
import type { UpdateFeatureFilterResponseAction } from './updateFeatureFilter.action';
import type { UpdateSearchStringFilterResponseAction } from './updateSearchStringFilter.action';
import type { UpdateTagsFilterResponseAction } from './updateTagsFilter.action';

export type QrCodeLinkManagerFilterAction =
  | ClearFilterEditorResponseAction
  | RevertFilterEditorResponseAction
  | ApplyFiltersResponseAction
  | UpdateSearchStringFilterResponseAction
  | UpdateCreatedDateRangeFilterResponseAction
  | UpdateArchivedFilterResponseAction
  | UpdateCampaignFilterResponseAction
  | UpdateFeatureFilterResponseAction
  | UpdateChannelFilterResponseAction
  | UpdateTagsFilterResponseAction;

export * from './clearFilterEditor.action';
export * from './revertFilterEditor.action';
export * from './applyFilters.action';
export * from './updateSearchStringFilter.action';
export * from './updateCreatedDateRangeFilter.action';
export * from './updateArchivedFilter.action';
export * from './updateCampaignFilter.action';
export * from './updateFeatureFilter.action';
export * from './updateChannelFilter.action';
export * from './updateTagsFilter.action';
